<div class="modal-wrapper">
    <div class="modal-header">
        <h2 class="modal-title">{{ title }} - {{ date | date: 'MMMM y' }}</h2>
        <button
            (click)="activeModal.dismiss()"
            aria-label="Close"
            class="close"
            type="button">
            <span aria-hidden="true">&times;</span>
        </button>
    </div>
    <div class="modal-body">
        <div *ngIf="chartInformationObjectType === ChartInformationObjectType.EMPLOYEE" class="m-b-2">
            <label class="m-r-2">Cost mode:</label>
            <button class="button button--small" [class.active]="costMode==='budgets'" (click)="setCostMode('budgets')">By budgets</button>
            <button class="button button--small" [class.active]="costMode==='hours'" (click)="setCostMode('hours')">By hours</button>
        </div>
        <ng-container *ngIf="turnoverDataInformation; else purchaseAndSale">
            <div class="table-container">
            <table
                #turnoverSort="matSort"
                [dataSource]="turnoverInformationDatasource"
                class="table-view" mat-table matSort>
                <ng-container matColumnDef="title">
                    <th
                        *matHeaderCellDef
                        mat-header-cell mat-sort-header>
                        Title
                    </th>
                    <td *matCellDef="let info" mat-cell>
                        <app-pill-invoice
                            [invoiceId]="info.documentId"
                            [title]="info.title"
                        >
                        </app-pill-invoice>
                    </td>
                    <td *matFooterCellDef class="text-align--right" mat-footer-cell>
                        Total:
                    </td>
                </ng-container>

                <ng-container matColumnDef="amount">
                    <th
                        *matHeaderCellDef
                        mat-header-cell mat-sort-header>
                        Amount
                    </th>
                    <td *matCellDef="let info" mat-cell>
                        {{ info.amount | currency: 'EUR' }}
                    </td>
                    <td *matFooterCellDef mat-footer-cell>
                        <b>{{ calculateTotalForTurnover() | currency: 'EUR' }}</b>
                    </td>
                </ng-container>

                <tr
                    *matHeaderRowDef="turnoverDisplayedColumns"
                    mat-header-row></tr>
                <tr
                    *matRowDef="let row; columns: turnoverDisplayedColumns"
                    mat-row></tr>
                <tr
                    *matFooterRowDef="turnoverDisplayedColumns"
                    mat-footer-row></tr>
            </table>
            </div>  
        </ng-container>

        <ng-template #purchaseAndSale>
            <ng-container *ngIf="purchaseInformation && saleInformation; else loading">
                <p class="m-b-2"><b>Margin</b>: {{calculateMargin() | currency: 'EUR'}}</p>
                <details open>
                    <summary>
                        <span class="sectiontitle sectiontitle--first summary__title">Income</span>
                        <i class="las la-angle-up summary__up-arrow"></i>
                    </summary>
                    <div>
                        <div class="table-container">
                        <table
                            #saleSort="matSort"
                            [dataSource]="saleInformationDatasource"
                            class="table-view"
                            mat-table matSort>
                            <ng-container matColumnDef="title">
                                <th
                                    *matHeaderCellDef
                                    mat-header-cell mat-sort-header>
                                    Title
                                </th>
                                <td *matCellDef="let info" mat-cell>
                                    <app-pill-invoice
                                        [invoiceId]="info.objectId"
                                        [linkedObjectId]="objectId"
                                        [refreshObjectId]="objectId"
                                        [refreshObjectType]="chartInformationObjectType === ChartInformationObjectType.EMPLOYEE ? 'EMPLOYEE' : (chartInformationObjectType === ChartInformationObjectType.PROJECT ? 'PROJECT' : 'CATEGORY')"
                                        [refreshFinancialMonth]="month + 1"
                                        [refreshFinancialYear]="year"
                                        [title]="info.title"
                                    >
                                    </app-pill-invoice>
                                </td>
                                <td *matFooterCellDef mat-footer-cell>
                                </td>
                            </ng-container>

                            <ng-container matColumnDef="invoiceNumber">
                                <th
                                    *matHeaderCellDef
                                    mat-header-cell mat-sort-header>
                                    Invoice number
                                </th>
                                <td *matCellDef="let info" mat-cell>
                                    {{ info.invoiceNumber }}
                                </td>
                                <td *matFooterCellDef class="text-align--right" mat-footer-cell>
                                    Total:
                                </td>
                            </ng-container>

                            <ng-container matColumnDef="amount">
                                <th
                                    *matHeaderCellDef
                                    mat-header-cell mat-sort-header>
                                    Amount
                                </th>
                                <td *matCellDef="let info" mat-cell>
                                    {{ info.amount | currency: 'EUR' }}
                                </td>
                                <td *matFooterCellDef mat-footer-cell>
                                    <b>{{ calculateTotal(saleInformation) | currency: 'EUR' }}</b>
                                </td>
                            </ng-container>

                            <ng-container matColumnDef="actions">
                                <th *matHeaderCellDef mat-header-cell class="td-small"></th>
                                <td *matCellDef="let info" mat-cell class="td-icon">
                                    <button
                                        *ngIf="info.objectId"
                                        (click)="unlinkInvoice(info, $event)"
                                        [disabled]="unlinkingInvoiceId === info.objectId"
                                        class="button button--icon button--small"
                                        container="body"
                                        ngbTooltip="Unlink invoice">
                                        <i *ngIf="unlinkingInvoiceId !== info.objectId" class="las la-times color--red"></i>
                                        <i *ngIf="unlinkingInvoiceId === info.objectId" class="las la-spinner la-spin"></i>
                                    </button>
                                </td>
                                <td *matFooterCellDef mat-footer-cell></td>
                            </ng-container>

                            <tr
                                *matHeaderRowDef="saleDisplayedColumns"
                                mat-header-row></tr>
                            <tr
                                *matRowDef="let row; columns: saleDisplayedColumns"
                                mat-row></tr>
                            <tr
                                *matFooterRowDef="saleDisplayedColumns"
                                mat-footer-row></tr>
                        </table>
                        </div>

                        <i class="las la-angle-down summary__down-arrow"></i>
                    </div>
                </details>

                <details open>
                    <summary>
                        <span class="sectiontitle summary__title">Cost</span>
                        <i class="las la-angle-up summary__up-arrow"></i>
                    </summary>
                    <div>
                        <div class="table-container">
                        <table
                            #purchaseSort="matSort"
                            [dataSource]="purchaseInformationDatasource"
                            class="table-view"
                            mat-table
                            matSort
                            [matSortActive]="chartInformationObjectType === ChartInformationObjectType.CATEGORY ? 'amount' : null"
                            [matSortDirection]="chartInformationObjectType === ChartInformationObjectType.CATEGORY ? 'desc' : 'asc'">
                            <ng-container matColumnDef="title">
                                <th
                                    *matHeaderCellDef
                                    mat-header-cell mat-sort-header>
                                    Title
                                </th>
                                <td *matCellDef="let info" mat-cell>
                                    <ng-container *ngIf="chartInformationObjectType === ChartInformationObjectType.CATEGORY && info?.objectId; else plainTitle">
                                        <app-pill-invoice
                                            [invoiceId]="info.objectId"
                                            [linkedObjectId]="objectId"
                                            [refreshObjectId]="objectId"
                                            [refreshObjectType]="'CATEGORY'"
                                            [refreshFinancialMonth]="month + 1"
                                            [refreshFinancialYear]="year"
                                            [title]="info.title | abbreviation">
                                        </app-pill-invoice>
                                    </ng-container>
                                    <ng-template #plainTitle>
                                        {{ info.title | abbreviation }}
                                    </ng-template>
                                </td>
                                <td *matFooterCellDef class="text-align--right" mat-footer-cell>
                                    <div>Total:</div>
                                    <div>Total hours: <b>{{ calculateTotalPurchaseHours() | number:'1.2-2' }} h</b></div>
                                </td>
                            </ng-container>

                            <ng-container matColumnDef="hours">
                                <th style="width: 60px;"
                                    *matHeaderCellDef
                                    mat-header-cell mat-sort-header>
                                    Hours (h)
                                </th>
                                <td *matCellDef="let info" mat-cell class="text-align--right">
                                    {{ (info._hours || 0) | number:'1.2-2' }} h
                                </td>
                                <td *matFooterCellDef mat-footer-cell>
                                </td>
                            </ng-container>

                            <ng-container matColumnDef="hourlyCost">
                                <th style="width: 100px;"
                                    *matHeaderCellDef
                                    mat-header-cell mat-sort-header>
                                    {{ costMode === 'budgets' ? 'Effective cost/h' : 'Hourly cost' }}
                                </th>
                                <td *matCellDef="let info" mat-cell class="text-align--right">
                                    {{ (info._hourlyCost || 0) | currency:'EUR':'symbol':'1.2-4' }}
                                </td>
                                <td *matFooterCellDef mat-footer-cell>
                                </td>
                            </ng-container>

                            <ng-container matColumnDef="amount">
                                <th
                                    *matHeaderCellDef
                                    mat-header-cell mat-sort-header>
                                    Amount
                                </th>
                                <td *matCellDef="let info" mat-cell>
                                    {{ info.amount | currency: 'EUR' }}
                                </td>
                                <td *matFooterCellDef mat-footer-cell>
                                    <b>{{ calculateTotalPurchase() | currency: 'EUR' }}</b>
                                </td>
                            </ng-container>

                            <ng-container matColumnDef="actions">
                                <th *matHeaderCellDef mat-header-cell class="td-small"></th>
                                <td *matCellDef="let info" mat-cell class="td-icon">
                                    <button
                                        *ngIf="info.objectId"
                                        (click)="unlinkInvoice(info, $event)"
                                        [disabled]="unlinkingInvoiceId === info.objectId"
                                        class="button button--icon button--small"
                                        container="body"
                                        ngbTooltip="Unlink invoice">
                                        <i *ngIf="unlinkingInvoiceId !== info.objectId" class="las la-times color--red"></i>
                                        <i *ngIf="unlinkingInvoiceId === info.objectId" class="las la-spinner la-spin"></i>
                                    </button>
                                </td>
                                <td *matFooterCellDef mat-footer-cell></td>
                            </ng-container>

                            <tr
                                *matHeaderRowDef="purchaseDisplayedColumns"
                                mat-header-row></tr>
                            <tr
                                *matRowDef="let row; columns: purchaseDisplayedColumns"
                                mat-row></tr>
                            <tr
                                *matFooterRowDef="purchaseDisplayedColumns"
                                mat-footer-row></tr>
                        </table>
                        </div>
                        <i class="las la-angle-down summary__down-arrow"></i>
                    </div>
                </details>
            </ng-container>
        </ng-template>
    </div>
</div>

<ng-template #loading>
    <app-loading-message></app-loading-message>
</ng-template>
